module.exports = __webpack_public_path__ + "static/media/box-background-with-separator-ghost.d88da807.png";